import App from '@/models/App'

export default class OrderingReceiverOrderComment extends App {
    static get entity() {
        return 'OrderingReceiverOrderComments'
    }

    static all() {
        return this.query().with('orderingAccount').get()
    }

    static fields() {
        return {
            id: this.attr(''),
            orderingOrderId: this.attr(''),
            orderingAccountId: this.attr(''),
            comment: this.attr(''),
            isMine: this.attr(false),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
            orderingAccount: this.attr({}), // FIXME
        }
    }

    static apiConfig = {
        actions: {
            fetch(orderingOrderId, params) {
                return this.get(
                    `/ordering/receiver/orders/${orderingOrderId}/comments`,
                    {
                        params: App.get(params),
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            create(orderingOrderId, params) {
                return this.post(
                    `/ordering/receiver/orders/${orderingOrderId}/comments`,
                    App.patch(params),
                    {
                        params: params,
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(orderingOrderId, orderingOrderCommentId, params) {
                return this.patch(
                    `/ordering/receiver/orders/${orderingOrderId}/comments/${orderingOrderCommentId}`,
                    App.patch(params),
                    {
                        params: params,
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(orderingOrderId, orderingOrderCommentId) {
                return this.delete(
                    `/ordering/receiver/orders/${orderingOrderId}/comments/${orderingOrderCommentId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: orderingOrderCommentId,
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
